module.exports = __webpack_public_path__ + "img/mcabee-logo.53efbe57.jpg";